import React, { useEffect, useState } from 'react';
import { StepProps, SPECIALTY_COLORS } from '../../types';
import { motion } from 'framer-motion';
import { ArrowRight, BarChart3 } from 'lucide-react';
export function RealityCheck({
  nextStep
}: StepProps) {
  const [startAnimation, setStartAnimation] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setStartAnimation(true), 300);
    return () => clearTimeout(timer);
  }, []);
  const data = [{
    label: 'Cardiologists',
    score: 75,
    color: SPECIALTY_COLORS.Cardiologist
  }, {
    label: 'Endocrinologists',
    score: 55,
    color: SPECIALTY_COLORS.Endocrinologist
  }, {
    label: 'Nephrologists',
    score: 30,
    color: SPECIALTY_COLORS.Nephrologist
  }, {
    label: 'PCPs',
    score: 25,
    color: SPECIALTY_COLORS.PCP
  }];
  return <div className="flex-grow flex flex-col py-12 px-6 overflow-y-auto bg-gray-50" data-id="element-387">
      <div className="max-w-4xl w-full mx-auto" data-id="element-388">
        <div className="text-center mb-12" data-id="element-389">
          <div className="inline-flex items-center justify-center p-3 bg-brand/10 text-brand rounded-full mb-6" data-id="element-390">
            <BarChart3 size={32} data-id="element-391" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-dark mb-4" data-id="element-392">
            The Reality Check
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-393">
            Observed trends suggest significant variance in how proactively
            specialties initiate early treatment.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 mb-10" data-id="element-394">
          <h3 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-8 text-center" data-id="element-395">
            Proactivity Index Score (0-100)
          </h3>

          <div className="space-y-8" data-id="element-396">
            {data.map((item, i) => <div key={item.label} className="relative" data-id="element-397">
                <div className="flex justify-between items-end mb-2" data-id="element-398">
                  <span className="text-lg font-bold text-dark" data-id="element-399">
                    {item.label}
                  </span>
                  <span className="text-2xl font-black" style={{
                color: item.color
              }} data-id="element-400">
                    {startAnimation ? item.score : 0}
                  </span>
                </div>
                <div className="h-6 bg-gray-100 rounded-full overflow-hidden" data-id="element-401">
                  <motion.div className="h-full rounded-full relative" style={{
                backgroundColor: item.color
              }} initial={{
                width: 0
              }} animate={{
                width: startAnimation ? `${item.score}%` : 0
              }} transition={{
                duration: 1.5,
                delay: 0.5 + i * 0.2,
                ease: 'easeOut'
              }} data-id="element-402">
                    <div className="absolute inset-0 bg-white/20 w-full h-full" style={{
                  backgroundImage: 'linear-gradient(45deg, rgba(255,255,255,0.15) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.15) 50%, rgba(255,255,255,0.15) 75%, transparent 75%, transparent)'
                }} data-id="element-403" />
                  </motion.div>
                </div>
              </div>)}
          </div>
        </div>

        <motion.div className="bg-brand text-white rounded-2xl p-8 mb-10 text-center shadow-lg" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: startAnimation ? 1 : 0,
        y: startAnimation ? 0 : 20
      }} transition={{
        duration: 0.8,
        delay: 2.5
      }} data-id="element-404">
          <p className="text-2xl font-medium leading-relaxed" data-id="element-405">
            "Only ~30% of nephrologists initiate early treatment. Cardiologists
            are ~2x more likely to escalate early."
          </p>
        </motion.div>

        <div className="flex justify-center pb-8" data-id="element-406">
          <motion.button initial={{
          opacity: 0
        }} animate={{
          opacity: startAnimation ? 1 : 0
        }} transition={{
          delay: 3
        }} onClick={nextStep} className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-dark rounded-full hover:bg-black transition-colors" data-id="element-407">
            See Your Gap Analysis
            <ArrowRight className="ml-2 w-5 h-5" data-id="element-408" />
          </motion.button>
        </div>
      </div>
    </div>;
}